/**
 * Ultra-smooth scroll function using requestAnimationFrame
 * Provides buttery smooth scrolling with easing
 */
export const smoothScrollTo = (target, offset = 0, duration = 800) => {
  const targetElement = typeof target === 'string' 
    ? document.querySelector(target) 
    : target;
  
  if (!targetElement) return;

  const startPosition = window.pageYOffset;
  const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - offset;
  const distance = targetPosition - startPosition;
  let startTime = null;

  // Easing function for smooth acceleration/deceleration
  const easeInOutCubic = (t) => {
    return t < 0.5 
      ? 4 * t * t * t 
      : 1 - Math.pow(-2 * t + 2, 3) / 2;
  };

  const animation = (currentTime) => {
    if (startTime === null) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    const progress = Math.min(timeElapsed / duration, 1);
    const ease = easeInOutCubic(progress);

    window.scrollTo(0, startPosition + distance * ease);

    if (timeElapsed < duration) {
      requestAnimationFrame(animation);
    } else {
      // Ensure we end exactly at the target position
      window.scrollTo(0, targetPosition);
    }
  };

  requestAnimationFrame(animation);
};

/**
 * Enhanced scrollIntoView with ultra-smooth behavior
 */
export const smoothScrollIntoView = (element, options = {}) => {
  const {
    behavior = 'smooth',
    block = 'start',
    inline = 'nearest',
    offset = 80
  } = options;

  if (typeof element === 'string') {
    element = document.querySelector(element);
  }

  if (!element) return;

  // Use custom smooth scroll for better control
  smoothScrollTo(element, offset, 1000);
};

